import { ReactNode } from 'react';

import { Root, TooltipText } from './Tooltip.ui';

type TooltipProps = {
  children: ReactNode;
  text: string;

  className?: string;
};

export const Tooltip = (props: TooltipProps) => {
  const { children, className, text } = props;

  return (
    <Root className={className}>
      {children}
      <TooltipText>{text}</TooltipText>
    </Root>
  );
};
